export default "__VITE_ASSET__DTQ$T9oG__"